import React, { useEffect, useState } from "react";
import {
  Tab,
  TabList,
  Button,
  Spinner,
  Label,
} from "@fluentui/react-components";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { Add20Filled, Edit20Filled, Dismiss20Regular, Save20Regular, Edit20Regular } from "@fluentui/react-icons";
import { useNavigate, useParams } from "react-router-dom";

import { getAccessToken } from "../../Services/GraphServices";
import {
  GetAgent,
  AddAgent,
  UpdateAgent,
  GetAllAgent,
} from "../../Services/HeedifyServices";
import "../CSS/AgentsComponent.css";
import AgentForm from "./AgentForm";
import AgentQueues from "./AgentQueues";
import { useAbility } from "../../Contexts/AbilityContext";
import { ReadOnlyFieldset } from "../GenericComponent/ReadOnlyFieldset";
import { useNotification } from "../GenericComponent/NotificationSystem";
export default function AgentsComponent(props) {
  const { instance, accounts } = useMsal();
  const activeAccount = accounts[0];
  const userId = activeAccount?.localAccountId;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { agentId } = useParams();
  const ability = useAbility();
  const { showSuccess, showError } = useNotification();
  const isCreateMode = agentId === "newAgent";
  const isEditMode = !isCreateMode;
  const [agent, setAgent] = useState({
    RowKey: "",
    id: "",
    displayName: "",
    email: "",
    scope: "",
    licenceLevel: "",
    enableCallRecording: false,
    callRecordingScope: "NULL",
    enableAllCallsReporting: false,
    recordingWebhook: "",
    agentQueueIds: [],
    agentQueueDetails: {},
    
  });
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [selectedTab, setSelectedTab] = useState("configuration");
  const [formValid, setFormValid] = useState(true);
  const [scopes, setScopes] = useState([]);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const fetchAgent = (agentId) => {
    getAccessToken(instance, activeAccount)
      .then((token) => {
        // Le backend exige un scope dans l'URL pour le check d'auth — on prend le 1er
        // scope dont l'user est admin, peu importe le scope réel de l'agent.
        const authScope = (props.SCOPES_NAMES && props.SCOPES_NAMES[0]) || "default";
        GetAgent(props.ACTIVE_TENANT, userId, agentId, token, authScope).then((result) => {
          setIsEditing(true);
          setAgent(result);
        });
      })
      .catch((err) => {
        console.error("Erreur ajout agent :", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  console.log('saving===>', saving);
  const fetchAgents = () => {
      getAccessToken(instance, activeAccount)
      .then((token) => {
    if (props.SCOPES_NAMES && props.SCOPES_NAMES.length > 0) {
      const promises = props.SCOPES_NAMES.map((scopeName) =>
        GetAllAgent(props.ACTIVE_TENANT, userId, scopeName , token)
      );

      Promise.all(promises)
        .then((results) => {
          // Fusionner tous les tableaux d'agents renvoyés
          const allAgents = results.flat();
          props.setAgents(allAgents);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des agents :", error);
        });
    }
      })
      .catch((err) => {
        console.error("Erreur lors du chargement des agents :", err);
      })
  };
  const createAgent = () => {
    // 🔐 Retirer les permissions avant de sauvegarder
    const { permissions, ...agentWithoutPermissions } = agent;
    getAccessToken(instance, activeAccount)
      .then((token) => {
        return AddAgent(props.ACTIVE_TENANT, userId, agent.scope, agentWithoutPermissions, token);
      })
      .then((result) => {
        if (result?.message === "Created" && result?.success === true) {
          fetchAgents();
          showSuccess(t("AGENT_CREATED_SUCCESS"));
          navigate("/agents");
        } else {
          // Display the actual error message from backend
          const errorMsg = result?.message || "Erreur inconnue";
          console.warn("Agent non créé :", result);
          showError(errorMsg);
        }
      })
      .catch((err) => {
        console.error("Erreur ajout agent :", err);
        showError(t("AGENT_CREATION_ERROR"));
      })
      .finally(() => {
        setSaving(false);
      });
      
  };
  const updateAgent = () => {
    // 🔐 Retirer les permissions avant de sauvegarder
    const { permissions, ...agentWithoutPermissions } = agent;

    getAccessToken(instance, activeAccount)
      .then((token) => {
        return UpdateAgent(
          props.ACTIVE_TENANT,
          userId,
          agent.RowKey,
          agent.scope,
          agentWithoutPermissions,
          token
        );
      })
      .then((result) => {
        if (result?.message === "Updated" && result?.success === true) {
          fetchAgents();
          showSuccess(t("AGENT_UPDATED_SUCCESS"));
          navigate("/agents");
        } else {
          showError(t("AGENT_UPDATE_FAILED"));
        }
      })
      .catch((err) => {
        console.error("Erreur mise à jour agent :", err);
        showError(t("AGENT_UPDATE_ERROR"));
      })
      .finally(() => {
        setSaving(false);
      });
     
  };


  const handleSubmit = () => {
    /* if (!agent.id || !agent.scope || !agent.licenceLevel) {
      alert("Veuillez remplir tous les champs obligatoires !");
      return;
    }*/
   
    if (isEditing) updateAgent();
    else createAgent();
  };
  useEffect(() => {
    if (props.SCOPES_NAMES?.length) {
      setScopes(props.SCOPES_NAMES);
    }

    if (agentId && agentId !== "newAgent") {
      // mode édition
      fetchAgent(agentId);
    } else {
      // mode création
      setLoading(false);
    }
  }, [agentId, props.SCOPES_NAMES]);

  // 🔐 Calculer les permissions basées sur le scope de l'agent
  useEffect(() => {
    if (!ability || !agent.scope) return;

    const scope = agent.scope;
    setAgent(prev => ({
      ...prev,
      permissions: {
        // `main` manquait : seules License et Profile étaient calculées. Sans lui, impossible de
        // savoir si l'utilisateur peut MODIFIER l'agent — l'écran s'ouvrant désormais en lecture,
        // c'est cette permission-là qui décide de l'enregistrement.
        main: {
          canCreate: ability.can("create", `Agent.main@${scope}`),
          canRead: ability.can("read", `Agent.main@${scope}`),
          canUpdate: ability.can("update", `Agent.main@${scope}`),
          canDelete: ability.can("delete", `Agent.main@${scope}`),
        },
        License: {
          canCreate: ability.can("create", `Agent.License@${scope}`),
          canRead: ability.can("read", `Agent.License@${scope}`),
          canUpdate: ability.can("update", `Agent.License@${scope}`),
          canDelete: ability.can("delete", `Agent.License@${scope}`),
        },
        Profile: {
          canCreate: ability.can("create", `Agent.Profile@${scope}`),
          canRead: ability.can("read", `Agent.Profile@${scope}`),
          canUpdate: ability.can("update", `Agent.Profile@${scope}`),
          canDelete: ability.can("delete", `Agent.Profile@${scope}`),
        },
      },
    }));
  }, [ability, agent.scope]);

  // Lecture seule : l'écran s'ouvre sur `canRead` (cf. la liste), l'enregistrement reste gardé
  // par `canUpdate`. En création, c'est `canCreate` qui gouverne, et on ne peut pas atteindre cet
  // écran sans lui.
  // Refus par DÉFAUT : `!== true`, pas `=== false`. Tant que les permissions ne sont pas
  // calculées — donnée pas encore arrivée, scope absent, `ability` pas prêt — la valeur est
  // `undefined`, et `undefined === false` vaut FAUX : l'écran se croyait modifiable pendant
  // ce laps de temps, et pour de bon si le scope manquait. En cas de doute, on refuse.
  const readOnly = isEditMode && agent.permissions?.main?.canUpdate !== true;

  // 🔐 Guard si aucune permission de lecture
  if (!ability) {
    return <div style={{ padding: "20px" }}>⏳ Chargement des permissions...</div>;
  }

 

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
          {/* --- Tabs --- */}

          <div className="div-wrapper" >
            <TabList
           
              selectedValue={selectedTab}
              onTabSelect={(_, data) => setSelectedTab(data.value)}
              className="tab-list"
            >
              <Tab
                className={`tab  ${selectedTab === "configuration" ? "selected" : ""
                  }`}
                value="configuration"
              >
                {t("AGENT_CONFIGURATION")}
              </Tab>
              <Tab
                className={`tab  ${selectedTab === "agents-queue" ? "selected" : ""
                  }`}
                value="agents-queue"
              >
                {t("AGENT_QUEUE")}
              </Tab>
            </TabList>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                icon={<Dismiss20Regular />}
                appearance="secondary"
                onClick={() => navigate("/agents")}
              >
                {t("CANCEL")}
              </Button>
              {/* Masqué en lecture seule, pas grisé : grisé, il laisse croire qu'il manque une
                  saisie, alors qu'il s'agit d'un droit absent. */}
              {!readOnly && (
              <Button
                icon={saving ? <Spinner size="tiny" /> : (isEditMode ? <Edit20Regular /> : <Save20Regular />)}
                className="btn-add-style"
                disabled={!formValid || saving}
                appearance="primary"
                onClick={(e) => {
                  e.preventDefault();
                  if (saving) return; // Prevent double click
                  setSaving(true);
                  // Use requestAnimationFrame to ensure state update is rendered
                  requestAnimationFrame(() => {
                    handleSubmit();
                  });
                }}
              >
                {saving ? t("SAVING") : t("SAVE")}
              </Button>
              )}
            </div>
          </div>
          {/* --- Contenu selon l’onglet --- */}
          {selectedTab === "configuration" && (
            <ReadOnlyFieldset readOnly={readOnly}>
            <AgentForm
              setFormValid={setFormValid}
              isUpdate={isEditMode}
              agentId={isEditMode ? agentId : "newAgent"}
              agent={agent}
              setAgent={setAgent}
              scopes={scopes}
              showAdvanced={showAdvanced}
              setShowAdvanced={setShowAdvanced}
              isEditing={isEditing}
              SCOPE_AVAILABLE_LICENCES={props.SCOPE_AVAILABLE_LICENCES}
              agentsProfiles={props.AGENT_PROFILES}
              permissions={agent.permissions}
            />
            </ReadOnlyFieldset>
          )}
          {selectedTab === "agents-queue" && (
            <div className="div-agent-queue-style">
              <Label weight="semibold">{t("AGENT_QUEUE_HINT")}</Label>
              <AgentQueues agent={agent} setAgent={setAgent} />
            </div>
          )}
        </div>
      )}
    </>
  );
}
